// WP50: the app's own confirm, in place of window.confirm and prompt. Y answers yes, N or Esc answers no, Enter presses the
// focused button, which starts on the safe answer. The question text is the page's own (data-confirm), unchanged.
import { icon } from "./icons";

let dialog: HTMLDialogElement | null = null;

function build(): HTMLDialogElement {
  const d = document.createElement("dialog");
  d.id = "kit-confirm";
  d.className = "confirm";
  d.setAttribute("role", "alertdialog");   // a question that must be answered before the page goes on
  d.setAttribute("aria-labelledby", "kit-confirm-text");
  const text = document.createElement("p");
  text.id = "kit-confirm-text";
  text.className = "confirm-text";
  const actions = document.createElement("div");
  actions.className = "confirm-actions";
  const no = document.createElement("button");
  no.type = "button";
  no.className = "btn";
  no.value = "no";
  no.innerHTML = "Cancel <kbd>N</kbd>";
  const yes = document.createElement("button");
  yes.type = "button";
  yes.className = "btn btn-primary";
  yes.value = "yes";
  yes.innerHTML = "Yes <kbd>Y</kbd>";
  actions.append(no, yes);
  const badge = document.createElement("div");
  badge.className = "confirm-icon";
  badge.appendChild(icon("question"));
  d.append(badge, text, actions);
  document.body.appendChild(d);
  return d;
}

/** Asks the question; resolves true only on Yes. */
export function ask(question: string, danger = false): Promise<boolean> {
  dialog ??= build();
  const d = dialog;
  if (d.open) return Promise.resolve(false);   // one question at a time; a second ask while one is up is a no
  (d.querySelector("#kit-confirm-text") as HTMLElement).textContent = question;
  d.classList.toggle("is-danger", danger);
  const no = d.querySelector<HTMLButtonElement>('button[value="no"]')!;
  const yes = d.querySelector<HTMLButtonElement>('button[value="yes"]')!;
  return new Promise((resolve) => {
    const finish = (answer: boolean) => {
      d.removeEventListener("keydown", onKey, true);
      d.oncancel = null;
      no.onclick = yes.onclick = null;
      if (d.open) d.close();
      resolve(answer);
    };
    d.oncancel = (e) => { e.preventDefault(); finish(false); };
    const onKey = (e: KeyboardEvent) => {
      const k = e.key.toLowerCase();
      if (k === "y") { e.preventDefault(); e.stopPropagation(); finish(true); }
      else if (k === "n" || k === "escape") { e.preventDefault(); e.stopPropagation(); finish(false); }
    };
    no.onclick = () => finish(false);
    yes.onclick = () => finish(true);
    d.addEventListener("keydown", onKey, true);
    d.showModal();
    no.focus();
  });
}
